import isObject from 'lodash/isObject';
import { devError, devLog, isBrowser } from '../../../../utils/browser';

const DEFAULT_ERROR_MESSAGE = 'Ocorreu um erro inesperado. Tente novamente mais tarde.';

export class RequestError extends Error {
  /**
   * @param {Object} data
   * @param {string} [msg]
   * @returns
   */
  static withData(data, msg = DEFAULT_ERROR_MESSAGE) {
    const error = new RequestError(msg);
    error.data = data;
    return error;
  }
}

export function getErrorMessage(exception, defaultMessage = DEFAULT_ERROR_MESSAGE) {
  let messages = [];

  const requestErrorBody =
    exception?.response?.data || exception?.data || exception?.response || exception;

  if (requestErrorBody && isObject(requestErrorBody)) {
    let errors =
      requestErrorBody.errors ||
      requestErrorBody.messages ||
      requestErrorBody.error ||
      requestErrorBody.message ||
      defaultMessage;

    if (!Array.isArray(errors)) {
      errors = [errors];
    }

    errors = errors.map((err) => {
      if (typeof err === 'string') {
        return err;
      }

      return err.message || err.error || err.code || `${err}`;
    });

    messages = errors;
  } else {
    messages = [exception?.message || defaultMessage];
  }

  const msg = messages.join(', ') || defaultMessage;

  if (`${msg}`.trim().toLowerCase().includes('failed to fetch')) {
    return 'Não foi possível conectar ao servidor. Tente novamente em alguns instantes.';
  }

  return msg;
}

export function getErrorData(exception, defaultMessage = DEFAULT_ERROR_MESSAGE) {
  const message = getErrorMessage(exception, defaultMessage);

  const requestErrorBody =
    exception?.response?.data ||
    exception?.data ||
    exception?.response ||
    exception?.rawErrorMessage ||
    exception;

  const errorData =
    requestErrorBody?.data?.errorData ||
    requestErrorBody?.errorData ||
    requestErrorBody?.data ||
    null;

  return {
    message,
    rawMessage: requestErrorBody?.rawErrorMessage,
    errorData,
    context: exception?.context || exception?.ctx || errorData?.context || 'generic',
  };
}

export function sendErrorToDataLayer(exception) {
  if (!isBrowser()) return;

  window.dataLayer = window.dataLayer || [];

  try {
    devLog('--------- sendErrorToDataLayer', exception);

    const parsed = getErrorData(exception);

    window.dataLayer.push({
      event: 'erro',
      message: parsed?.message,
      originalMessage: parsed?.rawMessage,
      context: parsed?.context,
      errorData: parsed?.errorData || null,
    });
  } catch (error) {
    devError('Error sending error message to dataLayer', error);
  }
}
